var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.6 3.6 0 8 0C12.4667 0 16 3.6 16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8ZM11 11.6667C11.2 11.8667 11.5333 11.8 11.6667 11.5333C11.8 11.3333 11.7333 11 11.4 10.8667C9.33333 9.6 6.73333 9.33333 3.66667 10C3.46667 10.0667 3.26667 10.3333 3.33333 10.6C3.4 10.8 3.66667 11 3.93333 10.9333C6.73333 10.2667 9.13333 10.5333 11 11.6667ZM12.6667 9.33333C12.4667 9.6 12.1333 9.73333 11.8 9.53333C9.66667 8.2 6.33333 7.8 3.86667 8.6C3.53333 8.66667 3.2 8.53333 3.13333 8.2C3.06667 7.86667 3.2 7.53333 3.53333 7.46667C6.46667 6.6 10.0667 7 12.5333 8.53333C12.7333 8.66667 12.8667 9.06667 12.6667 9.33333ZM3.46667 6.2C5.86667 5.46667 10.1333 5.6 12.7333 7.13333C13.0667 7.33333 13.5333 7.2 13.7333 6.93333C13.9333 6.53333 13.8 6.06667 13.4667 5.86667C10.5333 4.13333 5.86667 3.93333 3 4.8C2.66667 4.93333 2.4 5.33333 2.53333 5.73333C2.66667 6.06667 3.06667 6.33333 3.46667 6.2Z",
    fill: "#23B416"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.59515899.svg";
export { ForwardRef as ReactComponent };